import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';


const EXPIRATION_DATE = 15000;

export interface CacheValue {
  url: string;
  response: HttpResponse<Record<string, unknown>>;
  addedTime: number;
}
@Injectable()
export class CacheService {

  public cacheMap = new Map<string, CacheValue>(null);

  public getFromCache(req: HttpRequest<Record<string, unknown>>): HttpResponse<Record<string, unknown>> | undefined {
    const url = req.urlWithParams;

    const cached: CacheValue | undefined = this.cacheMap.get(url);

    if (!this.validate(cached)) {
      return undefined;
    }
    return (this.cacheMap.get(url))?.response;
  }

  public addToCache(req: HttpRequest<Record<string, unknown>>, response: HttpResponse<Record<string, unknown>>): void {
    const url = req.url;
    const entry = { url, response, addedTime: Date.now() };
    this.cacheMap.set(url, entry);
  }

  private validate(cached: CacheValue | undefined): boolean {
    let isValid = true;

    if (!cached) {
      return false;
    }

    const time = Date.now() - cached.addedTime;

    if (time > EXPIRATION_DATE) {
      isValid = false;
      this.cacheMap.delete(cached.url);
    }
    return isValid;
  }

}
